import { api } from ".";
import type { User } from "./backstage/users";

export interface UserFunction {
  funNo: number;
  funName: string;
  parentFunNo: number | null;
  url: string | null;
  seq: number | null;
}

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    currentUser: build.query<User, void>({
      query: () => "/users/current",
    }),
    functions: build.query<UserFunction[], void>({
      query: () => "/functions",
      providesTags: ["Function"],
    }),
    webCount: build.query<number, void>({
      query: () => "/web-count",
      keepUnusedDataFor: 3600,
    }),
  }),
  overrideExisting: false,
});

export const { useCurrentUserQuery, useFunctionsQuery, useWebCountQuery } =
  extendedApi;
